import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { LocalStorage } from "@ngx-pwa/local-storage";
import { NgxSpinnerService } from "ngx-spinner";
import { Validators, FormBuilder } from "@angular/forms";
import { CustomJsService } from "src/app/shared/custom-js.service";
import { ToastrService } from "ngx-toastr";
import { StadiumService } from "./../../stadium/stadium.service";
import { SportService } from "src/app/sports/sport.service";
import { UsersService } from "src/app/users/users.service";
import { ReportsService } from "../reports.service";
import { set } from "lodash";
import { Router } from "@angular/router";

declare var $: any;

@Component({
    selector: "app-add-schedule",
    templateUrl: "./add-schedule.component.html",
    styleUrls: ["./add-schedule.component.scss"],
})
export class AddScheduleComponent implements OnInit {
    public sports: any = null;
    public stadiums: any = null;
    public scheduleData: any;
    public sportsCategories: any = null;
    public users: any = null;
    public isShowForm: boolean = false;
    public selectedSpordId: number = 0;
    public categoryDetail: any = null;
    public isGroupReadOnly: boolean = true;
    public sportName: string = "";
    private fixesData = {};
    public sportTypes = [
        { value: 7, name: "แข่งแบบพบกันหมด" },
        { value: 1, name: "รอบคัดเลือก (ทั่วไป)" },
        { value: 6, name: "รอบ 16 ทีมสุดท้าย" },
        { value: 2, name: "รอบ 8 ทีมสุดท้าย" },
        { value: 3, name: "รอบรอง (4 ทีมสุดท้าย)" },
        { value: 8, name: "รอบรอง (4 ทีมสุดท้ายแบบชิงที่สามร่วม)" },
        { value: 4, name: "ชิงเหรียญทองแดง" },
        { value: 5, name: "ชิงเหรียญทอง" },
    ];

    public sportTypesData = [];

    public timePeriods = [];

    constructor(
        private sportService: SportService,
        private localStorage: LocalStorage,
        private spinner: NgxSpinnerService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private reportsService: ReportsService,
        private stadiumService: StadiumService,
        private usersService: UsersService,
        private cdr: ChangeDetectorRef,
        private router: Router
    ) {
        this.setFormData();
        this.spinner.show();
        this.timePeriods = this.generateTimePeriods(4, 22);
        this.localStorage.getItem("user").subscribe((data) => {
            if (data !== null) {
                this.getSport(data);
                this.getStadium();
            }

            this.usersService.getUsers().subscribe((res) => {
                this.users = res;
            });
        });
    }

    categoryChange(event: any) {
        this.sportService
            .getSportCategoryDetail(this.selectedSpordId, event.target.value)
            .subscribe((res) => {
                this.spinner.show();
                this.filterRound(res);
            });
    }

    filterRound(res) {
        console.log(res);
        this.categoryDetail = res;
        if (res.has_final_round_fixture && res.has_semi_final_round_fixture) {
            this.sportTypesData = this.sportTypes.filter(
                (sportType) =>
                    sportType.value !== 5 &&
                    sportType.value !== 4 &&
                    sportType.value !== 7
            );
        } else if (
            res.has_final_round_fixture &&
            !res.has_semi_final_round_fixture
        ) {
            this.sportTypesData = this.sportTypes.filter(
                (sportType) => sportType.value !== 5 && sportType.value !== 7
            );
        } else if (
            res.has_semi_final_round_fixture &&
            res.has_final_round_fixture
        ) {
            this.sportTypesData = this.sportTypes.filter(
                (sportType) =>
                    sportType.value !== 4 &&
                    sportType.value !== 7 &&
                    sportType.value !== 5
            );
        } else if (
            res.has_semi_final_round_fixture &&
            !res.has_final_round_fixture
        ) {
            this.sportTypesData = this.sportTypes.filter(
                (sportType) => sportType.value !== 4 && sportType.value !== 7
            );
        } else if (res.has_round_robin_fixture) {
            this.sportTypesData = this.sportTypes.filter(
                (sportType) => sportType.value === 7
            );
        } else {
            this.sportTypesData = this.sportTypes;
        }

        this.cdr.markForCheck();
        this.isShowForm = true;

        setTimeout(() => {
            this.datePicker();
            this.selectTwo(false);
            this.selectEvent(".time-select", "time");
            this.selectEvent(".stadium-select", "stadium_id");
            this.spinner.hide();
        }, 1500);
    }

    roundChange(event: any) {
        if (event === 1 || event === "1") {
            this.scheduleData.get("group").enable();
            this.isGroupReadOnly = false;
        } else {
            this.isGroupReadOnly = true;
            this.scheduleData.get("group").reset();
            this.scheduleData.patchValue({ group: " " });
        }
    }

    generateTimePeriods(
        startHour: number,
        endHour: number
    ): { value: string; name: string }[] {
        const timePeriods: { value: string; name: string }[] = [];
        const startTime = new Date();
        startTime.setHours(startHour, 0, 0, 0); // Start at specified hour

        const endTime = new Date();
        endTime.setHours(endHour, 0, 0, 0); // End at specified hour

        while (startTime <= endTime) {
            const hours = startTime.getHours().toString().padStart(2, "0");
            const minutes = startTime.getMinutes().toString().padStart(2, "0");
            const timeString = `${hours}:${minutes}:00`;
            timePeriods.push({
                value: timeString,
                name: `${hours}:${minutes}`,
            });
            startTime.setMinutes(startTime.getMinutes() + 5); // Increment by 5 minutes
        }

        return timePeriods;
    }

    setFormData() {
        this.scheduleData = this.formBuilder.group({
            sport_id: ["", Validators.required],
            category_id: [{ value: "", disabled: true }, Validators.required],
            type_id: ["", Validators.required],
            date: ["", Validators.required],
            time: ["", Validators.required],
            name: [""],
            stadium_id: ["", Validators.required],
            group: [""],
            users: [""],
            userOne: [""],
            userTwo: [""],
            userThree: [""],
            userFour: [""],
            userFive: [""],
            userSix: [""],
            userSeven: [""],
            userEight: [""],
            userNine: [""],
            userTen: [""],
            userEleven: [""],
            userTwelth: [""],
            userThirten: [""],
            userFourteen: [""],
            userFifteen: [""],
            userSixteen: [""],
            userSeventeen: [""],
            userEigthteen: [""],
            userNineteen: [""],
            userTwenty: [""],
            userTwentyOne: [""],
            userTwentyTwo: [""],
            userTwentyThree: [""],
            userTwentyFour: [""],
            userTwentyFive: [""],
            userTwentySix: [""],
            userTwentySeven: [""],
            userTwentyEigth: [""],
            userTwentyNine: [""],
            userThirty: [""],
        });
    }

    ngOnInit() {
        this.sportNameChange("");
    }

    getSport(token: any) {
        this.sportService.getSports(token).subscribe((res) => {
            this.sports = res;

            setTimeout(() => {
                this.datePicker();
                this.spinner.hide();
            }, 500);
        });
    }

    getStadium() {
        this.stadiumService.getAll().subscribe((res) => {
            this.stadiums = res.result;
        });
    }

    sportNameChange(value) {
        if (value === "") {
            this.scheduleData.controls.category_id.disable();
            this.sportsCategories = null;
            return;
        }

        this.isShowForm = false;
        this.selectedSpordId = value;
        this.sportCategory(value);
    }

    sportCategory(id) {
        const sportId = parseInt(id, 10);
        this.sports.forEach((value) => {
            if (value.id === sportId) {
                this.sportName = value.name;
                this.sportsCategories = value.categories;
            }
        });

        setTimeout(() => {
            this.scheduleData.get("group").reset();
            this.scheduleData.patchValue({ type_id: "" });
            this.scheduleData.patchValue({ time: "" });
            this.scheduleData.patchValue({ date: "" });
            this.scheduleData.patchValue({ group: " " });
            this.scheduleData.controls.category_id.enable();
        }, 500);
    }

    datePicker() {
        $(".fc-datepicker").datepicker({
            dateFormat: "yy-mm-dd",
            showOtherMonths: false,
            selectOtherMonths: false,
            minDate: "2025-01-16",
            maxDate: "2025-01-25",
            yearRange: "2025:2025",
            dayNamesMin: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
            hideIfNoPrevNext: true,
            onSelect: (dateText: any) => {
                this.scheduleData.controls.date.setValue(dateText);
            },
        });
    }

    selectTwo(isClear: boolean) {
        if (isClear) {
            $('[class*="select2-show-search]"').val(null).trigger("change");
            return false;
        }

        const selectElements: any = document.querySelectorAll(
            '[class*="select2-show-search"]'
        );

        for (let i = 0; i < selectElements.length; i++) {
            const className = `.select2-show-search-user${i + 1}`;
            const formControlName =
                selectElements[i].getAttribute("formControlName");

            this.selectEvent(className, formControlName);
        }
    }

    selectEvent(element: string, formControlName: string) {
        const options = { minimumResultsForSearch: "" };
        const $selectElement = $(element).select2(options);

        $selectElement.on("select2:select", (e: any) => {
            this.scheduleData.controls[formControlName].patchValue(
                e.params.data.id
            );

            this.cdr.markForCheck();
        });
    }

    scheduleDataSubmit(value: any) {
        this.spinner.show();
        this.fixesData = {
            sport_id: value.sport_id,
            category_id: value.category_id,
            type_id: value.type_id,
            date: value.date,
            time: value.time,
            name: value.name,
            stadium_id: value.stadium_id,
            group: value.group,
            // tslint:disable-next-line: max-line-length
            users: `${value.userOne},${value.userTwo},${value.userThree},${value.userFour},${value.userFive},${value.userSix},${value.userSeven},${value.userEight},${value.userNine},${value.userTen},${value.userEleven},${value.userTwelth},${value.userThirten},${value.userFourteen},${value.userFifteen},${value.userSixteen},${value.userSeventeen},${value.userEigthteen},${value.userNineteen},${value.userTwenty},${value.userTwentyOne},${value.userTwentyTwo},${value.userTwentyThree},${value.userTwentyFour},${value.userTwentyFive},${value.userTwentySix},${value.userTwentySeven},${value.userTwentyEigth},${value.userTwentyNine},${value.userThirty}`,
        };

        this.reportsService.add(this.fixesData).subscribe((res) => {
            this.spinner.hide();

            if (res.result) {
                this.fixesData = {};
                $('[class*="select2-show-search"]').val(null).trigger("change");
                $(".fc-datepicker").datepicker("destroy");
                $(".fc-datepicker").val("");
                this.ngOnInit();
                this.toastr.success(`เพิ่มรายการแข่งสำเร็จ`, "Success");
                this.router.navigate([
                    `/report/schedule-sport-overview/${value.sport_id}/${value.category_id}/${this.sportName}`,
                ]);
            }
        });
    }
}
